import StatusIndicator, {
  IndicatorProps,
} from "components/lib/statusIndicator";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Slot, SlotStatus } from "../../../../core/types";
import useMarketStrategy from "../../../../strategies/market/useMarketStrategy";

export const SlotBookingInfo = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const strategy = useMarketStrategy();

  const getSlotStatuses = (slot: Slot, isUpdateSlotStatusEnabled: boolean) => {
    const statuses = [];
    let variant;

    if (!isUpdateSlotStatusEnabled) {
      switch (slot.status) {
        case SlotStatus.CANCELED:
        case SlotStatus.LATE_CANCELED:
        case SlotStatus.NO_SHOW_ALL:
          variant = "error";
          break;
        case SlotStatus.NO_SHOW:
          variant = "purple";
          break;
        case SlotStatus.ORGANIZER_NO_SHOW:
          variant = "blue";
          break;
        default:
          variant = "";
      }

      if (
        ![SlotStatus.BOOKED, SlotStatus.UNAVAILABLE, SlotStatus.OPEN].includes(
          slot.status,
        )
      ) {
        statuses.push({
          testId: slot.status,
          label: t(slot.status),
          variant,
        });
      }
    }

    if (slot.status === SlotStatus.OPEN) {
      statuses.push({
        testId: "NOT_BOOKED",
        label: t("NOT_BOOKED"),
        variant: "transparent",
      });
    }

    const isPaid = !!slot.payed;
    if (slot.status !== SlotStatus.OPEN) {
      statuses.push({
        testId: isPaid ? "PAID" : "NOT_PAID",
        label: isPaid ? t("PAID") : t("NOT_PAID"),
        variant: isPaid ? "primary" : "orange",
      });
    }

    return statuses;
  };

  const slotStatuses = getSlotStatuses(slot, strategy.changeSlotStatus.enabled);

  return (
    <StatusContainer>
      <StatusesHeader>
        {t(`${strategy.patientCard.status_label}`)}
      </StatusesHeader>
      <StatusesRow>
        <StatusesColumn>
          {slotStatuses?.map((x) => (
            <StatusIndicator
              variant={x?.variant as IndicatorProps["variant"]}
              key={x.label}
              label={x.label}
              data-testid={`statusIndicator-${x.testId}`}
            />
          ))}
        </StatusesColumn>
      </StatusesRow>
    </StatusContainer>
  );
};

const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StatusesColumn = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;

  padding-right: 24px;
  padding-top: 6px;
`;

const StatusesHeader = styled.p`
  font-size: ${({ theme }) => theme.FONT.SIZE.SMALL};
  color: ${({ theme }) => theme.COLORS.GRAY_DARK};
  margin-right: 50px;
  padding-top: 10px;
`;
